import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';

export const CheckboxTextStyled = styled.span`
  font-size: 1.4rem;
`;

export const ActionButtonStyled = styled(Button)<{ $isSelected?: boolean }>`
  min-width: auto;
  border: 2px solid transparent;
  padding: 1rem 1.5rem;

  ${({ $isSelected = false }): CSSProp =>
    $isSelected
      ? css`
          color: ${colors.neutral.white};
          background-color: ${colors.blue[600]};

          &:hover {
            color: ${colors.neutral.white};
            background-color: ${colors.blue[600]};
            opacity: 0.7;
          }
        `
      : css`
          color: ${colors.blue[600]};
          background-color: ${colors.neutral.white};

          &:hover {
            color: ${colors.blue[600]};
            background-color: ${colors.neutral.white};
            opacity: 1;
          }
        `}

  &:disabled {
    color: ${colors.neutral.white};
    background-color: ${colors.neutral[300]};
    border: 2px solid transparent;
  }
`;

export const RelativeWrapperStyled = styled.div`
  position: relative;
`;

export const SectionContentStyled = styled.div`
  background-color: ${colors.neutral[100]};
  border-bottom: 0.1rem solid ${colors.neutral[300]};
  padding: 2rem 0;
  font-weight: 400;
  width: 100%;
`;

export const ActionsButtonsWrapperStyled = styled.div<{ $showSelfEnrollFeature: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ $showSelfEnrollFeature }): string => ($showSelfEnrollFeature ? '1rem 0.7rem' : '1rem 2rem')};

  @media (width <= 1321px) {
    justify-content: center;
    gap: 1rem;
  }
`;

export const SelectedAllBlockStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 0.6rem;
  box-shadow: ${boxShadows.dark[4]};
  text-transform: uppercase;

  svg {
    width: 2.4rem;
    margin: 0;
  }

  label {
    padding: 0.9rem 1.5rem;
    align-items: center;
  }
`;
